import FullscreenSlider from './components/FullscreenSlider';

import ScrollToTopButton from "./components/ScrollToTopButton";
import FooterSection from "./components/FooterSection";
import Header from "./components/Header";
import NosServices from './components/NosServices';
import Contact from './components/Contact';
import ScrollToTop from './components/Scrolltotop';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import NotreEquipe from './components/Notreequipe';

function HomePage() {
  return (
    <>
      <FullscreenSlider />
      {/* <ExpertiseSection /> */}
    </>
  );
}

// Create a separate component that uses useLocation
function AppContent() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <>
      <ScrollToTop />
      <div className="App">
        <Header />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<NosServices />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/equipe" element={<NotreEquipe />} />
          {/* Add more routes here as needed, for example:
          <Route path="/equipe" element={<NotreEquipe />} />
          */}
        </Routes>
        
        {/* Only show on non-home pages */}
        {!isHomePage && (
          <>
            <ScrollToTopButton />
            <FooterSection />
          </>
        )}
      </div>
    </>
  );
}

// App component wraps everything in Router
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;